import React, { useCallback, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './styles.less';

export const PaginationController = ( props ) => {
    const [ activePage, setActivePage ] = useState( 0 );
    
    // The total number of pages.
    const pageCount = useMemo( () => {
        const pageSize = ( props?.pageSize !== undefined ) ? props.pageSize : 0;
        const itemCount = ( props?.itemCount !== undefined ) ? props.itemCount : 0;

        if ( pageSize > 0 && itemCount > 0 ) {
            return Math.ceil( itemCount / pageSize );
        }

        // If a page size and total item count aren't valid, return only
        // one page for the page count.
        return 1;
    }, [ props.itemCount, props.pageSize ] );

    const handlePageChange = useCallback( ( pageIndex ) => {
        if ( props?.onChange ) {
            props.onChange( pageIndex, pageCount );
        }
    }, [ props, pageCount ] );

    const handlePageNext = useCallback( () => {
        if ( activePage < pageCount - 1 ) {
            const nextPageIndex = activePage + 1;
            setActivePage( nextPageIndex );
            handlePageChange( nextPageIndex );
        }
    }, [ activePage, setActivePage, pageCount, handlePageChange ] );

    const handlePagePrevious = useCallback( () => {
        if ( activePage > 0 ) {
            const nextPageIndex = activePage - 1;
            setActivePage( nextPageIndex );
            handlePageChange( nextPageIndex );
        }
    }, [ activePage, setActivePage, handlePageChange ] );

    // Construct the classes to use for the root component.
    const classes = classnames(
        'pagination-controller',
        { [ props.className ]: Boolean( props.className ) },
    );

    if ( Boolean( props?.hideOnSinglePage ) && pageCount <= 1 ) {
        return <></>;
    }

    return (
        <ul className={ classes }>
            <li
                className={ `page-left ${ ( activePage <= 0 ) ? 'disabled' : '' }` }
                onClick={ handlePagePrevious }
            >
                <img
                    src="images/page-left.svg"
                    alt=""
                />
            </li>
            <li className="label">
                <span>{ activePage + 1 } of { pageCount }</span>
            </li>
            <li
                className={ `page-right ${ ( activePage >= pageCount - 1 ) ? 'disabled' : '' }` }
                onClick={ handlePageNext }
            >
                <img
                    src="images/page-right.svg"
                    alt=""
                />
            </li>
        </ul>
    );
};

PaginationController.defaultProps = {
    // hideOnSinglePage: false,
};

PaginationController.propTypes = {
    className: PropTypes.string,
    itemCount: PropTypes.number,
    pageSize: PropTypes.number,
    onChange: PropTypes.func,
    // hideOnSinglePage: PropTypes.bool,
};
